import { render } from "./cpeCredits.vue?vue&type=template&id=5296005a&scoped=true"
import script from "./cpeCredits.vue?vue&type=script&lang=js"
export * from "./cpeCredits.vue?vue&type=script&lang=js"

import "./cpeCredits.vue?vue&type=style&index=0&id=5296005a&scoped=true&lang=scss"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5296005a"]])

export default __exports__